import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { createSelector } from 'reselect';

import { Urls, ModalTypes } from 'constants/constants';


import Scene, { selectSceneLibrary, selectDeletedScenes, } from 'store/models/Scene';
import RouteState, { pushTo, linkEditUrl } from 'store/RouteState';
import UIState from 'store/UIState';

import { ContentCenter, Title, Header, HeaderLeft, HeaderRight, Breadcrumbs,  Section, SectionTitle } from 'components/Content';
import { SceneManageList } from 'components/SceneItem';
import * as Icons from 'components/Svg';
import { NewButton } from 'components/Button';
import ScrollToTop from 'components/ScrollToTop';




// ======================
// STORE
// ======================
const selectors = createSelector(
  selectSceneLibrary,
  selectDeletedScenes,
  (library, deletedScenes) => Object.assign({ library, deletedScenes })
);

// ======================
// COMPONENT
// ====================== 

const SlidesScreen = ({match}) => {
  const { library, deletedScenes } = useSelector(s => selectors(s));
  const [loading, setLoading] = useState({
    scenes: false,
    deletedScenes: false,
  });
  let { base, custom, archive } = library ?? {};
  let active = [...base ?? [], ...custom ?? []];
  
  const dispatch = useDispatch();

  const fetchData = async () => {
    let isLoading = _.mapValues(loading, () => true);
    setLoading(isLoading);

    await dispatch(Scene.actions.getSceneLibrary())
    setLoading({..._.set(isLoading, 'scenes', false)});

    await dispatch(Scene.actions.fetchDeletedScenes())
    setLoading({..._.set(isLoading, 'deletedScenes', false)});

  }

  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, []);


  const onRestoreScene = async sceneId => dispatch(Scene.actions.restoreScene(sceneId));

  const onDeleteScene = async (sceneId) => {
    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, { 
      title: "Archive This Slide?",
      subtitle: "This will remove the slide from your Link Library, but your stats will remain",
      confirmText: "Yes, Archive It",
      onConfirm: async () => {
        dispatch(Scene.actions.deleteScene(sceneId));
      },
      onCancel: () => {}
    }));
  }

  return (<>
    <ScrollToTop />
    <ContentCenter className="links">
      <Header split={true}>
        <HeaderLeft>
          <Title>Slides Library</Title>
        </HeaderLeft>
        <HeaderRight>
        </HeaderRight>
      </Header>
      {!_.isEmpty(active) &&
        <Section size="l">
        <SectionTitle className="split">Used in Campaigns</SectionTitle>
        <SceneManageList
          scenes={active}
          onDelete={onDeleteScene}
          />
      </Section>}
      {!_.isEmpty(archive) &&
      <Section size="l">
        <SectionTitle className="split">Unused</SectionTitle>
        <SceneManageList
          scenes={archive}
          onDelete={onDeleteScene}/>
      </Section>}
      {!_.isEmpty(deletedScenes) &&
      <Section size="l">
        <SectionTitle className="split">Archived Slides</SectionTitle>
        <SceneManageList
          scenes={deletedScenes}
          onRestore={onRestoreScene}/>
      </Section>}
    </ContentCenter>
  </>)
}
export default SlidesScreen